export class Ticket {
    fromEmail: string;
    subject: string;
    description: string;
    fileToBeUploaded: File;
    //category: TicketCategory;

    // constructor(fromEmail: string) {
    //     if (fromEmail) {
    //         this.fromEmail = fromEmail;
    //     }
    // }

    constructor() { }
}

export enum TicketCategory {
    BUG,
    SERVICE
}